import React, {useEffect, useState, useMemo, useRef} from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import moment from "moment";
import {Link} from "react-router-dom";
import styles from "./EventCard.scss";
import getStaticFile from "utils/getStaticFile";

const DEFAULT_USER_IMAGE = getStaticFile("img/user_avatar.png");

export default function EventTile(props) {
    const [eventImage, setEventImage] = useState(DEFAULT_USER_IMAGE);
    const eventLink = useRef();

    useEffect(() => {
        if(!!props.event?.image) {
            setEventImage(props.event.image.file);
        }
    }, [props.event]);

    const eventDate = useMemo(() => {
        return moment(props.event.eventDate);
    }, [props.event]);

    const eventLocation = useMemo(() => {
        if (!props.event.location) {
            return null;
        }
        let cityState = `${props.event.location.city}, ${props.event.location.stateProvince}`;
        if (props.event.location.country !== "United States") {
            cityState = `${props.event.location.city}, ${props.event.location.country}`;
        }
        return cityState;
    }, [props.event]);

    const handleClick = () => {
        eventLink.current.click();
    }

    return (
        <div className={classnames(styles.root, { [styles.sidebar]: props.sidebar })} onClick={handleClick}>
            <div className={styles.dateBox}>
                <div className={styles.day}>{eventDate.format("DD")}</div>
                <div className={styles.month}>{eventDate.format("MMM")}</div>
            </div>
            <div className={styles.infoBox}>
                <div className={styles.info}>
                    <h3>
                        {props.event.title}
                        { !!eventLocation && <span className={styles.location}>{eventLocation}</span>}
                    </h3>
                    {props.event.shortDescription && (
                        <div
                            className={styles.text}
                            dangerouslySetInnerHTML={{__html: props.event.shortDescription}}
                        />
                    )}
                </div>
                <div className={styles.eventLink}>
                    <Link
                        to={`/details/${props.event.uniqueId}/`}
                        className={"btn buttonNoBorder buttonNoBg small"}
                        ref={eventLink}
                    >
                        Learn More >
                    </Link>
                </div>
            </div>
        </div>
    )

}

EventTile.propTypes = {
    event: PropTypes.object.isRequired,
    sidebar: PropTypes.bool,
}